var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#fff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.71,144.416c0-5.284-3.687-9.69-8.616-10.866V79.872l53.285,34.484v43.97c0,0,0.28-0.131,0.746-0.327 c0.822,22.806,10.4,43.446,25.477,58.504c15.776,15.786,37.63,25.569,61.705,25.56c24.076,0.01,45.939-9.773,61.706-25.56 c15.077-15.058,24.664-35.698,25.476-58.504c0.476,0.196,0.746,0.327,0.746,0.327v-43.97l67.942-43.959L260.308,0l-155.87,70.396 v63.154c-4.938,1.176-8.617,5.582-8.617,10.866v3.201h31.889V144.416z M189.081,152.845c17.522-4.21,45.967-6.656,71.227,11.025 c25.261-17.681,53.715-15.235,71.228-11.025c0.019,0.654,0.047,1.307,0.047,1.961c0,19.706-7.963,37.471-20.874,50.401 c-12.92,12.91-30.694,20.873-50.401,20.873c-19.707,0-37.472-7.963-50.4-20.873c-12.911-12.93-20.864-30.695-20.874-50.401 C189.034,154.152,189.071,153.499,189.081,152.845z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.014,183.858h9.503c6.18,0,11.193-5.014,11.193-11.193v-18.381H95.821v18.381 C95.821,178.844,100.835,183.858,107.014,183.858z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.672,343.704c0-0.886,0-1.736,0-2.651c0-33.738-16.589-76.38-56.852-94.137c0,0-2.502,1.998-7.02,4.612 l-44.492,75.288l-44.5-75.288c-4.509-2.615-7.011-4.612-7.011-4.612c-40.263,17.756-56.842,60.399-56.842,94.137 c0,0.915,0,1.765,0,2.651H87.551v44.586h336.899v-44.586H368.672z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.231,
    y: 403.3,
    className: "st0",
    width: 267.538,
    height: 108.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.b85a991585a5bdb5395881fce69f7e39.svg";
export { ForwardRef as ReactComponent };